<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m48 19.84a34.09 34.09 0 1 1 -34.08 34.09 34.12 34.12 0 0 1 34.08-34.09m0-4a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09z"
      fill="#4f2b1b"
    />
    <path
      d="m41.35 41.7a2.59 2.59 0 0 1 -3 2.25 2.71 2.71 0 0 1 -2.35-2.95 2.59 2.59 0 0 1 3-2.24 2.71 2.71 0 0 1 2.35 2.94z"
      fill="#fff"
    />
    <path
      d="m41.14 41.64c-.52 3.09-5.21 2.49-4.88-.6s5-2.4 4.87.66c0 .27.41.27.43 0a3 3 0 0 0 -2.56-3.16 2.85 2.85 0 0 0 -3.18 2.46c-.42 3.61 5.13 4.36 5.73.77.05-.28-.36-.4-.41-.13z"
      fill="#4f2b1b"
    />
    <path
      d="m39.85 41.5a1.14 1.14 0 0 1 -1.29 1 1.19 1.19 0 0 1 -1-1.29 1.13 1.13 0 0 1 1.28-1 1.19 1.19 0 0 1 1.01 1.29z"
      fill="#4f2b1b"
    />
    <path
      d="m67.32 34.26c-1.49 1.43-4.17 3.41-6.25 2.36l3.65-5.34c.78-1.14-1.07-2.21-1.85-1.08l-3.31 4.85c-1-2-.17-4.77.88-6.62a1.07 1.07 0 0 0 -1.85-1.08c-1.6 2.81-2.46 6.87-.34 9.61l-6.66 9.73c-.78 1.14 1.07 2.22 1.85 1.08l6.42-9.38c3 1.74 6.67-.4 9-2.61.97-.96-.54-2.47-1.54-1.52z"
      fill="#85c441"
    />
    <path
      d="m39.85 30.56-.08-.11-.13-.05s-1.11-.43-.76-3.87v-.4h-.33c-.58 0-1.06 1.47-1.14 2.1-.1.85-.17 1.35-.21 1.65-.07.46-.1.67.2.82a1.7 1.7 0 0 1 .26.53l.08.21h.23.61c.72 0 1.11-.12 1.28-.39a.52.52 0 0 0 -.01-.49z"
      fill="#85c441"
    />
    <path
      d="m69.55 51.78c-2.45 3.34-7.18 3.36-10.78 2.49-1.33-.33-1.91 1.73-.57 2.06 3.63.88 7.7.83 10.79-1.19-1.33 7.19-4.92 13.55-12.75 15.24a28.39 28.39 0 0 1 -9.59.33 1.09 1.09 0 0 0 -1.59-.28 21.86 21.86 0 0 1 -2.5-.7 1.12 1.12 0 0 0 -1.74-.73 11.79 11.79 0 0 1 -2.69-1.76c-7-6.15-9.57-17.51-6.86-26.2 1.66-5.33 6.28-11.95 12.16-7.18a11.34 11.34 0 0 1 3.37 12.29c-.45 1.3 1.61 1.86 2.06.57 2.49-7.15-3.81-20.38-12.88-16-2.66 1.28-4.53 3.92-5.77 6.84l-3.07-1.56c-.39-.19-.95.13-.79.61l.87 2.61-2 1.36c-.34.24-.36.88.13 1l3.34.64c-.15.73-.28 1.43-.38 2.1a29.54 29.54 0 0 0 3.91 18.88 19 19 0 0 0 8.05 7.61 28.8 28.8 0 0 0 .38 10.87c.3 1.34 2.37.77 2.06-.57a26.48 26.48 0 0 1 -.42-9.44 20.54 20.54 0 0 0 2.35.7c.18 3.32 1.82 6.67 3.25 9.56.61 1.24 2.46.16 1.85-1.08-1.2-2.43-2.61-5.26-2.92-8.07a30.37 30.37 0 0 0 8 0c10.94-1.39 15.67-10.29 16.75-20.46.1-1.17-1.47-1.32-2.02-.54z"
      fill="#4f2b1b"
    />
    <path
      d="m46.76 27.72-.39-.1-.13.34c-1.3 3.43-5.69 5-5.74 5l-.66.23.58.4a22.4 22.4 0 0 0 3.22 1.69l.21.09.16-.16c1.3-1.23 1.67-1.91 2.83-5.14.21-.56.44-2.13-.08-2.35z"
      fill="#85c441"
    />
    <path
      d="m42.9 60.16-12.84 18.55c-.79 1.14 1.06 2.21 1.84 1.08l12.85-18.55c.78-1.13-1.07-2.2-1.85-1.08z"
      fill="#85c441"
    />
    <path
      d="m42.4 48.22a6.84 6.84 0 0 0 -6.78 7.05c.2 4.63 4.54 6.47 8.59 6.5s8.79-.57 11.79-3.7c3.88-4.09 3.59-10.74 3.17-15.92a1.09 1.09 0 0 0 -1.83-.75c-3 3-6.11 6.58-10.65 6.82-1.37.07-1.38 2.21 0 2.14 5.22-.27 8.66-4 12.17-7.45l-1.86-.76c.57 7.11.35 15.53-8.09 17.11-3.16.59-8.43 1.21-10.48-1.89s.53-6.83 3.95-7c1.37-.07 1.37-2.21 0-2.14z"
      fill="#4f2b1b"
    />
  </svg>
</template>
